import React, {Fragment} from "react";
import {dayColSpan, getDayMonthFromDate, getDays, getWeeks} from "./analyticsUtils";

export default function ({reportAnalytics, enablePtoAnalytics}) {
  return (
    <tr>
      <th></th>
      {reportAnalytics.phases.map(phase => (
        <Fragment>
          {
            getWeeks(reportAnalytics.weeks[phase.guid], phase, reportAnalytics, enablePtoAnalytics).map(week => (
              <Fragment>
                {getDays(week.days, phase, week, reportAnalytics, enablePtoAnalytics).map(day => (
                  <th data-align="center" key={week.numInPhase + day} colSpan={dayColSpan(reportAnalytics, phase, week, day, enablePtoAnalytics)}>{getDayMonthFromDate(day)}</th>
                ))}
                {!enablePtoAnalytics && <th data-align="center">Avg</th>}
              </Fragment>
            ))
          }
          {!enablePtoAnalytics && <th data-align="center">Avg</th>}
        </Fragment>
      ))}
      {!enablePtoAnalytics && <th data-align="center">Avg</th>}
    </tr>
  )
}
